export default String.raw`
.refunds-page-title {
    margin: 0 0 24px;
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
    color: $primaryColorFont;
}

.refunds-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;
    margin-bottom: 32px;
    color: $primaryColorFont;
}

.refunds-info {
    align-self: flex-start;
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    max-width: 800px;

    &__title {
        margin: 0;
        font-size: 20px;
        font-weight: 600;
        line-height: 28px;
        color: $primaryColorFont;
    }

    &__intro {
        margin: 0;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        color: $primaryColorFont;
    }

    &__hint {
        margin: 4px 0 0;
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        color: $breadcrumbs;
    }
}

.refunds-steps {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;

    &__item {
        display: flex;
        align-items: center;
        gap: 12px;
    }

    &__number {
        flex-shrink: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background-color: #f3f3f3;
        color: $primaryColor;
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
    }

    &__text {
        margin: 0;
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        color: $primaryColorFont;

        strong {
            font-weight: 600;
        }
    }
}

.refunds-cta {
    box-sizing: border-box;
    width: 100%;
    max-width: 578px;
    padding: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    background-color: $bgColor;
    border: 1px solid $lightBorderColor;
    border-radius: 8px;

    &__header {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
        width: 100%;
    }

    &__title {
        margin: 0;
        font-size: 24px;
        font-weight: 600;
        line-height: 32px;
        text-align: center;
        color: $primaryColorFont;
    }

    &__description {
        margin: 0;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        text-align: center;
        color: $breadcrumbs;
    }

    &__button {
        width: 100%;
        text-decoration: none;
    }
}

.refund-form-section {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-bottom: 32px;
}

.refund-form {
    box-sizing: border-box;
    width: 100%;
    max-width: 578px;
    padding: 40px;
    background-color: $bgColor;
    border: 1px solid $lightBorderColor;
    border-radius: 8px;

    &__header {
        display: flex;
        flex-direction: column;
        gap: 12px;
        margin-bottom: 32px;
    }

    &__title {
        margin: 0;
        font-size: 24px;
        font-weight: 600;
        line-height: 32px;
        color: $primaryColorFont;
    }

    &__description {
        margin: 0;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: $breadcrumbs;
    }

    &__body {
        display: flex;
        flex-direction: column;
    }

    .form__input-wrapper {
        .form__input-value {
            &.validation-error-js {
                border-color: $dangerColor;
                color: $dangerColor;
            }
        }

        .form__invalid-input {
            position: static;
            display: block;
            margin: 4px 0 0;
            padding-left: 16px;
            text-align: left;
            color: $dangerColor;
            font-size: 12px;
            font-weight: 400;
            line-height: 16px;
        }
    }

    &__submit {
        width: 100%;
        margin-top: 4px;
    }

    &__login-info {
        margin: 16px 0 0;
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: $primaryColorFont;
    }

    &__login-link {
        color: $primaryColor;
        font-weight: 600;
        cursor: pointer;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }
}
`